/* eslint-disable no-param-reassign */

const TABLIST_SELECTOR = '.cards-experiences__tabs[role="tablist"]';

function initExperienceTabs(block) {
  if (block.getAttribute('data-cards-experiences-tabs-init') === '1') {
    return;
  }

  const tablist = block.querySelector(TABLIST_SELECTOR);

  if (!tablist) {
    return;
  }

  const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
  const panels = Array.from(block.querySelectorAll('[role="tabpanel"]'));

  if (tabs.length < 2 || panels.length < 2 || tabs.length !== panels.length) {
    return;
  }

  block.setAttribute('data-cards-experiences-tabs-init', '1');

  const activate = (index) => {
    tabs.forEach((tabElement, i) => {
      const selected = i === index;
      tabElement.setAttribute('aria-selected', selected ? 'true' : 'false');
      tabElement.setAttribute('tabindex', selected ? '0' : '-1');
      tabElement.classList.toggle('cards-experiences__tab--active', selected);
    });

    panels.forEach((panelElement, i) => {
      if (i === index) {
        panelElement.removeAttribute('hidden');
      } else {
        panelElement.setAttribute('hidden', '');
      }
    });
  };

  tabs.forEach((tabElement, index) => {
    tabElement.addEventListener('click', () => {
      activate(index);
    });

    tabElement.addEventListener('keydown', (event) => {
      let nextIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (index + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex !== null) {
        event.preventDefault();
        activate(nextIndex);
        tabs[nextIndex].focus();
      }
    });
  });

  activate(0);
}

function resetExperienceTabs() {
  document.querySelectorAll('.cards-experiences[data-cards-experiences-tabs]').forEach((block) => {
    block.removeAttribute('data-cards-experiences-tabs-init');
  });
}

function initCardsExperiencesBlocks() {
  document.querySelectorAll('.cards-experiences[data-cards-experiences-tabs]').forEach((block) => {
    initExperienceTabs(block);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/cards-experiences', () => {
      resetExperienceTabs();
      initCardsExperiencesBlocks();
    });
  }

  initCardsExperiencesBlocks();
});
